@if (date()) {
    <span [id]="uid" [title]="relativeTime()">{{ date() | date: 'MM/dd/yyyy h:mm a' : undefined : 'en-US' }}</span>
    <sh-tooltip [label]="relativeTime()" [target]="uid" placement="top" variation="short"></sh-tooltip>
}
